import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { string } from 'prop-types';
import './PlaceholderCarrusel.scss';
import HtmlDecode from '../../utils/htmlDecode';
import { isNodeMyContent } from '../../utils/Utils';

export const PlaceholderCarrusel = ({ title, description, img }) => {
  const { navData } = useSelector(state => state?.cvNavData);
  const { code: codeMenu } = navData?.selected || {};


  return (
    <Fragment>
      {isNodeMyContent(codeMenu) && (
        <div className="placeholder-carrusel">
          <h2 className="placeholder__title ">{HtmlDecode(title)}</h2>
          <div className="placeholder__carrusel">
            <section className="carrusel__section-text">
              <p className="section-text__descrption">{description}</p>
            </section>
            <section className="placeholder__section-items">
              <img src={img} />
              <img src={img} />
              <img src={img} />
              <img src={img} />
              <img src={img} />
              <img src={img} />
              <img src={img} />
              <img src={img} />
              <img src={img} />
              <img src={img} />
              <img src={img} />
              <img src={img} />
            </section>
          </div>
        </div>
      )}
    </Fragment>
  );
};

PlaceholderCarrusel.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  img: string.isRequired,
};
